module.exports = __webpack_public_path__ + "img/RCT08.66d775d8.svg";